import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { dealersApi } from "../../api/endpoints";

export function useDealers(params?: { search?: string; status?: string }) {
  return useQuery({
    queryKey: ["dealers", params],
    queryFn: () => dealersApi.list(params).then((r) => r.data),
    // Aramada her tuşta iskelete düşmemek için önceki sonucu koru.
    placeholderData: keepPreviousData,
  });
}

export function useDealerStats() {
  return useQuery({
    queryKey: ["dealers", "stats"],
    queryFn: () => dealersApi.stats().then((r) => r.data),
  });
}

export function useUpdateDealerStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: string }) =>
      dealersApi.updateStatus(id, status).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["dealers"] }),
  });
}

export function useMarkDealerRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => dealersApi.markRead(id).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["dealers"] }),
  });
}

export function useDeleteDealer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => dealersApi.delete(id).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["dealers"] }),
  });
}
